import React, { Component } from 'react'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { Redirect } from 'react-router-dom'
import { Layout, Form, Row, Col, Button } from 'antd'
import HeaderTmp from '../Template/HeaderTmp'
import Footer from '../Template/FooterTmp'
import CardObj from './Component/CardObj'
import moment from 'moment'
import './Event.css'

const { Content } = Layout
// const FormItem = Form.Item
class Event extends Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect: false,
      slug: props.match.params.slug,
      bib: '',
    }
  }

  componentDidMount() {
    const tail = this.props.data.variables.slug.split('-')
    const title = tail[tail.length - 1] === 'ecer' ? 'e-Certificate - Powered By Thai.run' : 'e-Slip - Powered By Thai.run'
    document.title = title
  }

    _handleSubmit = (e) => {
      e.preventDefault()
      // console.log('submited')
      this.props.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.setState({
            redirect: true,
            bib: values.search,
          })
        }
      })
    }

    render() {
      if (this.state.redirect) {
        return <Redirect to={`/${this.state.slug}/${this.state.bib}`} />
      }
      if (!this.props.data.event) {
        return <Button type="primary" style={{ marginLeft: '48%', marginTop: '22%' }} shape="circle" loading />
      }
      if (this.props.data.event.eSlip === false) {
        return <Redirect to="/" />
      }
      const { event } = this.props.data
      const { date, slug } = event

      const startDate = moment(date, 'D/MM/YYYY')
      const isStart = moment().isSameOrAfter(startDate)
      const canDownload = (slug === 'BS42-2019-ecer') ? isStart : true

      return (
        <Layout>
          <HeaderTmp />
          <Row type="flex" justify="center">
            <Col xs={24} sm={24} md={16} lg={16} xl={16} xxl={16}>
              <Content style={{
  marginTop: 96, minHeight: 'calc(100vh - 64px - 69px - 37px)', background: '#fff', textAlign: 'center',
}}
              >
                {/* <CardObj event={event.event} slug={event.slug} logo={event.logoImage} /> */}
                {canDownload ? <CardObj event={event} /> : <img src="https://storage.googleapis.com/s.cert.thai.run/BS42-2019-ecer/assets/undownload-ecer.png" alt="show can't download" style={{ width: '90%', height: 'auto'}} /> }
              </Content>
            </Col>
          </Row>
          <Footer />
        </Layout>
      )
    }
}

const EventQuery = gql`
    query queryEvent($slug: String) {
        event(filter: {
            slug: $slug
        }) {
            event
            slug
            title
            partner
            logoImage
            date
            eSlip
            _id
        }
    }
`
const EventWithData = graphql(EventQuery, {
  options: props => ({
    variables: {
      slug: props.match.params.slug,
    },
  }),
})(Event)

const WrappedEvent = Form.create()(EventWithData)

export default WrappedEvent



// WEBPACK FOOTER //
// ./src/Event/Event.js